import React from 'react';
import '../css/FooterLink.css';

const FooterLink = ({link, socialMediaType, imageLink}) => {
  return (
    <a className="footer-link" href={link} target="_blank" rel="noopener noreferrer">
      <img
        className="social-media"
        alt={`${socialMediaType}`}
        src={imageLink}
      />
    </a>
  );
}

export default FooterLink;
